'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ReturnsConfigProvider = require('../providers/ReturnsConfigProvider.js');

const useCurrencyConfig = () => {
  const {
    localeCountry,
    localeLanguage,
    includeCurrency
  } = ReturnsConfigProvider.useReturnsConfig();
  return {
    locale: `${localeLanguage}_${localeCountry}`,
    includeCurrency: !!includeCurrency
  };
};

exports["default"] = useCurrencyConfig;
